import { AppInstallation } from "../app";
import { Backup } from "../backup";
import { Registry } from "../container";
import { Conversation } from "../conversation";
import { Wallet } from "../customer";
import { Customer, CustomerInvite } from "../customer";
import { Certificate, Domain, Ingress } from "../domain";
import { FinderProfile } from "../fyndr";
import { FinderProfileRequest } from "../fyndr/FinderProfileRequest";
import { Invoice } from "../invoice";
import { MailAddress } from "../mail";
import { ExtensionInstance } from "../marketplace";
import { Order } from "../order";
import { Project, ProjectInvite } from "../project";
import { Server } from "../server";
import { User } from "../user";
import { DataModel } from "./DataModel.js";
import { language } from "./i18n/setup.js";

interface AggregateReferenceData {
  aggregate: string;
  domain: string;
  id: string;
  parent?: AggregateReferenceData;
}

export class AggregateReference extends DataModel<AggregateReferenceData> {
  public readonly aggregate?:
    | Project
    | Server
    | Customer
    | AppInstallation
    | ExtensionInstance
    | User
    | Backup
    | CustomerInvite
    | ProjectInvite
    | MailAddress
    | Domain
    | Certificate
    | Ingress
    | Conversation
    | Order
    | Invoice
    | Registry
    | Wallet
    | FinderProfile
    | FinderProfileRequest;
  public readonly translatedType: string;
  public readonly parentAggregate?: Customer;

  public constructor(data: AggregateReferenceData) {
    super(data);
    const { aggregate, domain, id, parent } = data;
    if (
      domain === Server.aggregateMetaData.domain &&
      aggregate === Server.aggregateMetaData.aggregate
    ) {
      this.aggregate = Server.ofId(id);
      this.translatedType = language.default.aggregate.server;
    } else if (
      domain === Customer.aggregateMetaData.domain &&
      aggregate === Customer.aggregateMetaData.aggregate
    ) {
      this.aggregate = Customer.ofId(id);
      this.translatedType = language.default.aggregate.customer;
    } else if (
      domain === Project.aggregateMetaData.domain &&
      aggregate === Project.aggregateMetaData.aggregate
    ) {
      this.aggregate = Project.ofId(id);
      this.translatedType = language.default.aggregate.project;
    } else if (
      domain === AppInstallation.aggregateMetaData.domain &&
      aggregate === AppInstallation.aggregateMetaData.aggregate
    ) {
      this.aggregate = AppInstallation.ofId(id);
      this.translatedType = language.default.aggregate.appInstallation;
    } else if (
      domain === ExtensionInstance.aggregateMetaData.domain &&
      aggregate === ExtensionInstance.aggregateMetaData.aggregate
    ) {
      this.aggregate = ExtensionInstance.ofId(id);
      this.translatedType = language.default.aggregate.extensionInstance;
    } else if (
      domain === User.aggregateMetaData.domain &&
      aggregate === User.aggregateMetaData.aggregate
    ) {
      this.aggregate = User.ofId(id);
      this.translatedType = language.default.aggregate.user;
    } else if (
      domain === Backup.aggregateMetaData.domain &&
      aggregate === Backup.aggregateMetaData.aggregate
    ) {
      this.aggregate = Backup.ofId(id);
      this.translatedType = language.default.aggregate.backup;
    } else if (
      domain === ProjectInvite.aggregateMetaData.domain &&
      aggregate === ProjectInvite.aggregateMetaData.aggregate
    ) {
      this.aggregate = ProjectInvite.ofId(id);
      this.translatedType = language.default.aggregate.projectInvite;
    } else if (
      domain === CustomerInvite.aggregateMetaData.domain &&
      aggregate === CustomerInvite.aggregateMetaData.aggregate
    ) {
      this.aggregate = CustomerInvite.ofId(id);
      this.translatedType = language.default.aggregate.customerInvite;
    } else if (
      domain === MailAddress.aggregateMetaData.domain &&
      aggregate === MailAddress.aggregateMetaData.aggregate
    ) {
      this.aggregate = MailAddress.ofId(id);
      this.translatedType = language.default.aggregate.mailAddress;
    } else if (
      domain === Domain.aggregateMetaData.domain &&
      aggregate === Domain.aggregateMetaData.aggregate
    ) {
      this.aggregate = Domain.ofId(id);
      this.translatedType = language.default.aggregate.domain;
    } else if (
      domain === Certificate.aggregateMetaData.domain &&
      aggregate === Certificate.aggregateMetaData.aggregate
    ) {
      this.aggregate = Certificate.ofId(id);
      this.translatedType = language.default.aggregate.certificate;
    } else if (
      domain === Ingress.aggregateMetaData.domain &&
      aggregate === Ingress.aggregateMetaData.aggregate
    ) {
      this.aggregate = Ingress.ofId(id);
      this.translatedType = language.default.aggregate.ingress;
    } else if (
      domain === Conversation.aggregateMetaData.domain &&
      aggregate === Conversation.aggregateMetaData.aggregate
    ) {
      this.aggregate = Conversation.ofId(id);
      this.translatedType = language.default.aggregate.conversation;
    } else if (
      domain === Order.aggregateMetaData.domain &&
      aggregate === Order.aggregateMetaData.aggregate
    ) {
      this.aggregate = Order.ofId(id);
      this.translatedType = language.default.aggregate.order;
    } else if (
      domain === Invoice.aggregateMetaData.domain &&
      aggregate === Invoice.aggregateMetaData.aggregate
    ) {
      this.aggregate = Invoice.ofId(id);
      this.translatedType = language.default.aggregate.invoice;
    } else if (
      domain === Registry.aggregateMetaData.domain &&
      aggregate === Registry.aggregateMetaData.aggregate
    ) {
      this.aggregate = Registry.ofId(id);
      this.translatedType = language.default.aggregate.registry;
    } else if (
      domain === Wallet.aggregateMetaData.domain &&
      aggregate === Wallet.aggregateMetaData.aggregate &&
      parent?.aggregate === Customer.aggregateMetaData.aggregate &&
      parent.domain === Customer.aggregateMetaData.domain
    ) {
      this.translatedType = language.default.aggregate.wallet;
      this.aggregate = Wallet.ofId(parent.id);
      this.parentAggregate = Customer.ofId(parent.id);
    } else if (
      domain === FinderProfile.aggregateMetaData.domain &&
      aggregate === FinderProfile.aggregateMetaData.aggregate
    ) {
      this.aggregate = FinderProfile.ofCustomerId(id);
      this.translatedType = language.default.aggregate.finderProfile;
    } else if (
      domain === FinderProfileRequest.aggregateMetaData.domain &&
      aggregate === FinderProfileRequest.aggregateMetaData.aggregate
    ) {
      this.aggregate = FinderProfileRequest.ofCustomer(id);
      this.translatedType = language.default.aggregate.finderProfileRequest;
    } else {
      this.translatedType = "unknown aggregate";
    }
  }
}
